import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryPurchaseOrderCreateFromSheetBody,
  IInventoryPurchaseOrderCreateFromSheetResponse,
} from "@/api_framework/api_modals/Inventory";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useLoaderActions } from "@/app/hooks/useLoaderActions";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

export const useCreatePOFromSheetAPI = () => {
  const configuration = useConfiguration();
  const { enable, disable } = useLoaderActions("isCreatePOFromSheetInProgress");
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (body: IInventoryPurchaseOrderCreateFromSheetBody) => {
      enable();
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: IInventoryPurchaseOrderCreateFromSheetResponse = await axios
          .post(
            `${INVENTORY_MODULE?.PURCHASE_ORDER_CREATE_FROM_SHEET?.baseURL}`,
            body,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
        .then((res: AxiosResponse<IInventoryPurchaseOrderCreateFromSheetResponse>) => {
          disable();
          if (res.data.status) {
            toast.success(res.data.message || "Purchase orders created successfully");
          } else {
            toast.error(res.data.message || "Failed to create purchase orders");
          }
          return res.data;
        })
        .catch((e: AxiosError) => {
          disable();
          if (e.response?.status === 422) {
            return e.response.data as IInventoryPurchaseOrderCreateFromSheetResponse; // Return error response
          }
          captureError(e);
          return e.response?.data as IInventoryPurchaseOrderCreateFromSheetResponse;
        });
      return response;
    } catch (e: any) {
      disable();
      toast.error("Server Error: " + e.message);
      return null;
    }
  }, [dispatch]);
  return execute;
};
